import { loadTemplate } from '../../template/index.js';
import { displayAlert } from './render.js';
import { handleClick } from './handlers.js';

let alertContainer = null;

/**
 * Initialize alert module
 * Preloads templates and registers global helpers
 */
export async function initAlert() {
	alertContainer = document.getElementById('wpcore-alert');
	// Ensure global namespace
	window.wpcore = window.wpcore || {};

	// Load templates once
	await Promise.all([
		loadTemplate('alert.ejs'),
	]);

	// Attach event delegation listener
	if (alertContainer) {
		alertContainer.addEventListener('click', handleClick);
	}

	window.wpcore.showAlert = (type = 'info', title = '', message = '') => {
		return showAlert(type, title, message);
	};

	window.wpcore.removeAlert = () => {
		if (alertContainer) {
			alertContainer.innerHTML = '';
		}
	};

	// Alias
	window.wpcore.alert = window.wpcore.showAlert;
}

function showAlert(type = 'info', title = '', message = '') {
	if (!alertContainer) {
		alertContainer = document.getElementById('wpcore-alert');
	}

	if (!alertContainer) {
		console.warn('[Alert] Container #wpcore-alert not found');
		return;
	}

	return displayAlert(alertContainer, { type, title, message });
}
